import { PasswordRecoveryRepository } from '@/Account/domain/PasswordRecoveryRepository'
import { PasswordRecoveryModel, ResetPasswordModel } from '@/Account/domain/PasswordRecoveryModel'
import { HttpMethod, HttpModel } from '@/Shared/domain'
import { axiosFetch, axiosFetchV2 } from '@/Shared/infrastructure'
import { passwordRecovery, updatePassword, passwordRecoveryEmailResend, verifyUpdatePasswordToken } from '@/Shared/infrastructure/endpoints'
import { PasswordRecoveryData, ResetPasswordData, TokenData } from '../ui/hooks'

export function createPasswordRecoveryRepository(): PasswordRecoveryRepository {
  return new ApiPasswordRecoveryRepository()
}

type PasswordRecoveryApiForm = {
  email: string
  merchantId: string
  legalId: string
}

type ResetPasswordApiForm = {
  token: string
  password: string
  passwordRepeat: string
}

const convertFormToApi = (form: PasswordRecoveryData): PasswordRecoveryApiForm => ({
  email: form.email,
  merchantId: form.merchantId,
  legalId: form.legalId,
})

const convertResetFormToApi = (form: ResetPasswordData): ResetPasswordApiForm => ({
  token: form.token,
  password: form.password,
  passwordRepeat: form.passwordRepeat,
})

export class ApiPasswordRecoveryRepository implements PasswordRecoveryRepository {
  async VerifyIdentity(data: PasswordRecoveryData): Promise<HttpModel<PasswordRecoveryModel>> {

    const response = await axiosFetch(passwordRecovery, HttpMethod.POST, convertFormToApi(data))

    if (!response.data) {
      return {
        data: {} as PasswordRecoveryModel,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }

  async ResendEmail(data: PasswordRecoveryData): Promise<HttpModel<string>> {
    return await axiosFetch(passwordRecoveryEmailResend, HttpMethod.POST, convertFormToApi(data))
  }

  async UpdatePassword(data: ResetPasswordData, userName: string): Promise<HttpModel<ResetPasswordModel>> {
    const response = await axiosFetchV2(updatePassword, HttpMethod.POST, convertResetFormToApi(data),
      {
        headers: {
          'userName': userName,
        }
      })


    if (!response.data) {
      return {
        data: {} as ResetPasswordModel,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }

  async ValidateToken(data: TokenData): Promise<HttpModel<boolean>> {

    const { token, userName } = data
    const queryString = `?token=${token}`

    const response = await axiosFetchV2(verifyUpdatePasswordToken + queryString, HttpMethod.GET, {},
      {
        headers: {
          'userName': userName,
        }
      })
      
    return response.data
  }
}
